pageId = 'page-signup'
page = '#' + pageId

$ ->
  $(document).on 'ajax:success', "#{ page } .form", (e, result) ->
    simple.util.storage.remove('welcomeStep')  if result.success

  tower.initMobileVerification $(page)
